import React, { useEffect, useState } from 'react'
import { Helmet } from 'react-helmet-async'
import { Link as RouterLink, useNavigate, useLocation } from 'react-router-dom';
import { KeyboardArrowLeftRounded } from '@mui/icons-material';
import { Autocomplete, Box, Dialog, DialogTitle, DialogContent, DialogActions, Fab, Button, Card, Grid, CardContent, IconButton, Popover, Container, FormControl, InputLabel, MenuItem, Select, Stack, Table, TableBody, TableCell, TableHead, TableContainer, TableRow, TextField, Typography, TablePagination, Tooltip } from '@mui/material';
import Iconify from '../components/iconify/Iconify';
import { downloadDocument, getDocumentUploadDetails, getInspectionDetails, updateConductInspect, getStatusList, getQualityParameterList, updateWorklog, fetchTolerance, fetchWorklog } from './qualityApi';
import { DataGrid } from '@mui/x-data-grid';
import { QuickSearchToolbar } from '../../payment/common/commonFunctions';
import { Add as AddIcon, Delete as DeleteIcon, CloudUpload as CloudUploadIcon, Close as CloseIcon } from '@mui/icons-material';
import { format } from "date-fns";
import { FILE_NAME_VALIDATION_ERROR, allowedFileTypes } from '../../common/constants';
import { capitalizeFunction, fileNameValidation, openTextFieldMaxLength, recordedValueMaxLength, VALIDATION } from '../../common/commonValidations';
import { toast } from 'react-toastify';
import { ConfirmationPopover } from '../../common/commonPopovers/confirmationPopover';
import { useTranslation } from 'react-i18next';
import { handleNumberFieldFocus } from '../../common/commonFunction';
import { AttachFileIcon, SaveIcon, SubmitIcon } from '../../common/icons';

function ConductInspectionPage() {
    const { state } = useLocation();
    const navigate = useNavigate();
    const { t } = useTranslation();
    const [open, setOpen] = useState(null);
    const [openAssign, setOpenAssign] = useState(null);
    const [openId, setOpenId] = useState(null);
    const [remove, setRemove] = useState();
    const [selectedItemForAttachment, setSelectedItemForAttchment] = useState({
        bundleId: null,
        qualityParameter: null
    });
    const [label, setLabel] = useState("")

    const [inspectionDetails, setInspectionDetails] = useState();
    const [status, setStatus] = useState(null);
    const [bundleIdArr, setBundleIdArr] = useState();
    const [selectedBundleIds, setSelectedBundleIds] = useState([]);
    const [updateResponse, setUpdateResponse] = useState();
    const [statusList, setStatusList] = useState();
    const [qualityParameterList, setQualityParameterList] = useState();
    const [worklogDetails, setWorklogDetails] = useState();
    const [commentsRow, setCommentsRow] = useState([]);
    const [qualityRows, setQualityRows] = useState([]);
    const [errorMessage, setErrorMessage] = useState({
        fileUploadError: ''
    });
    const [selectedFiles, setSelectedFiles] = useState([]);
    const [qualityDocumentMasterEntity, setQualityDocumentMasterEntity] = useState([]);
    const [logModalOpenSubmit, setLogModalOpenSubmit] = useState(false);
    const handleLogModalCloseSubmit = () => setLogModalOpenSubmit(false);
    const handleLogModalOpenSubmit = () => setLogModalOpenSubmit(true);
    const [isApiCalled, setIsApiCalled] = useState(false);


    const handleOpenMenu = (event, selectedItem) => {
        setSelectedItemForAttchment({
            bundleId: selectedItem?.bundleId,
            qualityParameter: selectedItem?.qualityParameter
        })
        setOpen(event.currentTarget);
        setRemove(selectedItem)
    };
    const handleCloseMenu = () => {
        setOpen(null);
        setOpenId(null);
        setOpenAssign(null);
    };

    function onCancelRow(remove) {
        setQualityRows(qualityRows.filter((row) => row.id !== remove.id));
        setOpen(null);
    }


    // const submitDocuments = () => {
    //     const tempArr = [...qualityDocumentMasterEntity]
    //         selectedFiles?.map((item) => {
    //             tempArr.push({
    //                 documentName: item?.fileName,
    //                 documentBlobName: item?.blobFileName,
    //                 documentContainerName: "paymentfiles",
    //                 isActive: 1,
    //                 bundleId: "string",
    //                 qualityParameter: "string",
    //             });
    //         });
    //         setQualityDocumentMasterEntity(tempArr);
    // }

    const onDeleteFile = (documentBlobName) => {
        const tempArr = (qualityDocumentMasterEntity?.map(item => {
            if (item?.documentBlobName === documentBlobName) {
                item.isActive = 0
            }
            return item
        }
        ))
        setQualityDocumentMasterEntity(tempArr);
    }

    function assignInspection(e, selectedItem) {
        setOpenAssign(e.currentTarget);
        // setOpen(null);
        setSelectedItemForAttchment({
            bundleId: selectedItem?.bundleId,
            qualityParameter: selectedItem?.qualityParameter
        })
        // setOpen(e.currentTarget);
        // setRemove(selectedItem)
    }



    const handleDocumentChange = (e, type) => {
        const choosenFiles = Array.prototype.slice.call(e.target.files)
        if (allowedFileTypes.indexOf(e.target.files[0].type) < 0) {
            return;
        }
        if (choosenFiles.some(file => file.size > 5000000)) {
            setErrorMessage({ ...errorMessage, fileUploadError: 'One of the selected file size is more than 5MB, select the files which size less than 5MB' });
        }
        else if (choosenFiles.some(file => file.name.split('.').length > 2)) {
            setErrorMessage({ ...errorMessage, fileUploadError: 'Double extension file detected' });
        }
        else if (choosenFiles.some(file => fileNameValidation(file.name))) {
            setErrorMessage({ ...errorMessage, fileUploadError: FILE_NAME_VALIDATION_ERROR });
        }
        else {
            setErrorMessage({ ...errorMessage, fileUploadError: '' });
            choosenFiles.map((file) => {
                getDocumentUploadDetails(file, qualityDocumentMasterEntity, setQualityDocumentMasterEntity, selectedItemForAttachment)
            })
        }
    };

    useEffect(() => {
        if (inspectionDetails) {
            setStatus(inspectionDetails?.status)
            const tempArr = inspectionDetails?.bundleIdEntity?.map(({ id, bundleId, workOrderTableId, qualityWorkLogEntity }) => ({
                id,
                bundleId,
                workOrderTableId,
                qualityWorkLogEntity: qualityWorkLogEntity?.map(({ bundleTableId, qualityParameter, materialCode, triggeringReason, actualQuantity, recordedQuantity, newQuantity, toleranceLimit, minimumLimit, maximumLimit, comments }) => ({
                    bundleTableId, qualityParameter, actualQuantity, recordedQuantity, newQuantity, toleranceLimit, minimumLimit, maximumLimit, comments, inspectionOrderId: state?.inspectionOrderId, materialCode, triggeringReason,
                }))
            }))
            setBundleIdArr(tempArr);
            fetchWorklog(state?.inspectionOrderId, setWorklogDetails)
        }
    }, [inspectionDetails]);

    useEffect(() => {
        if (worklogDetails) {
            const tempArr = []
            worklogDetails?.map((item, index) => {
                tempArr.push({
                    "id": index,
                    "comments": item?.comments,
                    "updtdBy": item?.updtdBy,
                    "updatedOn": item?.updatedOn
                });
            })
            setCommentsRow(tempArr);
        }
    }, [worklogDetails]);

    const onAddNewChecklist = () => {
        const tempArr = [...qualityRows]
        tempArr.unshift({
            actualQuantity: null,
            bundleId: null,
            comments: null,
            id: qualityRows?.length + 1,
            materialCode: null,
            triggeringReason: null,
            qualityParameter: null,
            recordedQuantity: null,
            newQuantity: null,
            toleranceLimit: null,
            minimumLimit: null,
            maximumLimit: null,
            bundleTableId: null,
            inspectionOrderId: state?.inspectionOrderId
        });
        setQualityRows(tempArr);
    }

    const onAddComment = () => {
        const tempArr = [...commentsRow]
        tempArr.unshift({
            "id": commentsRow?.length + 1,
            "comments": ""
        });
        setCommentsRow(tempArr);
    }

    // const onConfirmSubmit = () => {
    //     handleLogModalCloseSubmit();
    //     updateConductInspect(state?.inspectionOrderId, "Closed", true, bundleIdArr, setUpdateResponse, navigate, qualityDocumentMasterEntity, triggeringArr?.some(word => inspectionDetails?.bundleIdEntity[0]?.qualityWorkLogEntity[0]?.triggeringReason?.includes(word)), inspectionDetails?.inspectionStorageLocation, inspectionDetails?.inspectionLocationType)

    // }

  
 
    const onConfirmSubmit = async () => {
        if (isApiCalled) return;
        setIsApiCalled(true);
        try {
            await updateConductInspect(state?.inspectionOrderId, "Closed", true, bundleIdArr, setUpdateResponse, navigate, qualityDocumentMasterEntity, triggeringArr?.some(word => inspectionDetails?.bundleIdEntity[0]?.qualityWorkLogEntity[0]?.triggeringReason?.includes(word)), inspectionDetails?.inspectionStorageLocation, inspectionDetails?.inspectionLocationType);
            await new Promise((resolve) => setTimeout(resolve, 1000));
        } catch (error) {
            console.error("API failed:", error);
        } finally {
            setLogModalOpenSubmit(false);
            setIsApiCalled(false);
        }
    };

    const onSubmit = (submitFlag) => {
        qualityRows?.map((item) => {
            if (item?.bundleTableId === null && (item?.toleranceLimit !== null || item?.minimumLimit !== null || item?.maximumLimit !== null)) {
                bundleIdArr?.forEach((mainItem) => {
                    if (mainItem?.bundleId === item?.bundleId) {
                        delete item?.id;
                        delete item?.bundleId;
                        mainItem?.qualityWorkLogEntity?.push({ ...item, id: mainItem?.id })
                    }
                })
            }
        });
        if (submitFlag && !triggeringArr?.some(word => inspectionDetails?.bundleIdEntity[0]?.qualityWorkLogEntity[0]?.triggeringReason?.includes(word))
            && bundleIdArr?.filter(obj => obj?.qualityWorkLogEntity?.some(innerObj => innerObj?.recordedQuantity === null))?.length > 0) {
            toast.error("Please complete inspection for all the bundle Id's")
        }
        else if (submitFlag && triggeringArr?.some(word => inspectionDetails?.bundleIdEntity[0]?.qualityWorkLogEntity[0]?.triggeringReason?.includes(word))
            && bundleIdArr?.filter(obj => obj?.qualityWorkLogEntity?.some(innerObj => innerObj?.newQuantity === null))?.length > 0) {
            toast.error("Please complete inspection for all the bundle Id's")
        }
        else {

            submitFlag ? handleLogModalOpenSubmit() :
                updateConductInspect(state?.inspectionOrderId, "Open", submitFlag, bundleIdArr, setUpdateResponse, navigate, qualityDocumentMasterEntity, triggeringArr?.some(word => inspectionDetails?.bundleIdEntity[0]?.qualityWorkLogEntity[0]?.triggeringReason?.includes(word)), inspectionDetails?.inspectionStorageLocation, inspectionDetails?.inspectionLocationType)
        }
    }

    const handledropdownChange = (e) => {
        setStatus(e.target.value)
    }

    const handleMultiBundleSelect = (e, value) => {
        setSelectedBundleIds(value)
        let idCounter = 1;
        const tempArr = value?.map((item) =>
            item?.qualityWorkLogEntity?.map((quaItem) => ({ id: idCounter++, bundleId: item?.bundleId, ...quaItem }))
        ).flat();
        setQualityRows(prevItems => [
            ...prevItems?.filter(item => item?.bundleTableId === null && value?.find((valueItem) => (valueItem?.bundleId === item?.bundleId))), ...tempArr
        ]);
    }

    const handleNewCheckListChange = (e, selectedId, selectedRow) => {
        const tempArr = qualityRows?.map(item => {
            if (item?.id === selectedId) {
                if (e.target.name === "recordedQuantity" || e.target.name === "newQuantity") {
                    const maxLengthInput = e.target.value.slice(0, 5);
                    e.target.value = maxLengthInput;
                    item[e.target.name] = e.target.value
                }
                else if (e.target.name === "comments") {
                    item[e.target.name] = VALIDATION.noSpecialCharacterValidation(e.target.value)
                }
                else {
                    item[e.target.name] = e.target.value
                }
                if (e.target.name === "bundleId") {
                    item.materialCode = qualityRows?.find((quaItem) => (quaItem?.bundleId === selectedRow?.bundleId && quaItem?.materialCode !== null))?.materialCode
                    item.triggeringReason = qualityRows?.find((quaItem) => (quaItem?.bundleId === selectedRow?.bundleId && quaItem?.triggeringReason !== null))?.triggeringReason
                }
            }
            return item
        })
        setQualityRows(tempArr);
        if (e.target.name === "qualityParameter") {
            fetchTolerance(e.target.value, triggeringArr?.some(word => inspectionDetails?.bundleIdEntity[0]?.qualityWorkLogEntity[0]?.triggeringReason?.includes(word)) ? qualityRows?.find((quaItem) => (quaItem?.bundleId === selectedRow?.bundleId))?.materialCode : inspectionDetails?.materialCode, qualityRows, setQualityRows, selectedId)
        }
    }

    const handleChange = (e, selectedQualityParameter, selectedBundleId) => {
        const tempArr = bundleIdArr?.map(item => {
            if (item?.bundleId === selectedBundleId) {
                item.qualityWorkLogEntity = item?.qualityWorkLogEntity?.map((quaItem) => {
                    if (quaItem?.qualityParameter === selectedQualityParameter) {
                        if (e.target.name === "recordedQuantity" || e.target.name === "newQuantity") {
                            const maxLengthInput = e.target.value.slice(0, 5);
                            e.target.value = maxLengthInput;
                            quaItem[e.target.name] = e.target.value
                        }
                        else if (e.target.name === "comments") {
                            quaItem[e.target.name] = VALIDATION.noSpecialCharacterValidation(e.target.value)
                        }
                        else {
                            quaItem[e.target.name] = e.target.value
                        }

                    }
                    return quaItem;
                });
            }
            return item;
        }
        )
        setBundleIdArr(tempArr)
    }

    const handleCommentChange = (e, selectedId) => {

        const tempArr = (commentsRow?.map(item => {
            if (item?.id === selectedId) {
                item[e.target.name] = VALIDATION.noSpecialCharacterValidation(e.target.value)
            }
            return item;
        }
        ))
        setCommentsRow(tempArr)
    }

    const onCancelComment = (row) => {
        setCommentsRow(commentsRow.filter((item) => item.id !== row.id))
    }

    useEffect(() => {
        getInspectionDetails(state?.inspectionOrderId, setInspectionDetails, setQualityDocumentMasterEntity, setLabel)
        getStatusList(setStatusList)
        getQualityParameterList(setQualityParameterList)
    }, []);

    const triggeringArr = ["ISS", "PIT"]
    const inspectionDetailsColumns = [
        { field: 'inspectionOrderId', headerName: 'Inspection Work Order', width: 180 },
        {
            field: 'materialCode', headerName: 'Material Code', width: 180, hide: triggeringArr?.some(word => inspectionDetails?.bundleIdEntity[0]?.qualityWorkLogEntity[0]?.triggeringReason?.includes(word)) && true,
            renderCell: (params) => {
                return (
                    <div>{params?.row?.categoryOfInspection === "Grievance" ? params?.row?.bundleIdEntity[0]?.qualityWorkLogEntity[0]?.materialCode : params?.row?.materialCode}</div>
                )
            }
        },
        { field: 'inspectorName', headerName: 'Inspector', width: 150 },
        { field: 'inspectionLocationType', headerName: 'Inspection Location Type', width: 180 },
        { field: 'inspectionStorageLocation', headerName: 'Inspection Location(Storage location)', width: 180 },
        {
            field: 'dateOfInspection', headerName: 'Date of Inspection', width: 200,
            renderCell: (params) => {
                return (
                    <div>{format(new Date(params?.row?.dateOfInspection), 'dd-MM-yyyy')}</div>
                )
            }
        },
        {
            field: 'status', headerName: 'Status', width: 150,
            // renderCell: (params) => {
            //     return (
            //         <FormControl >
            //             <InputLabel id="select-inspector-list-label">Status</InputLabel>
            //             <Select
            //                 labelId="select-inspector-list-label"
            //                 id="select-inspector"
            //                 label="Status"
            //                 sx={{ minWidth: 120 }}
            //                 name="status"
            //                 value={status || ''}
            //                 size="small"
            //                 onChange={(e) => handledropdownChange(e)}>
            //                 <MenuItem value=""><em>Select</em></MenuItem>
            //                 {
            //                     statusList?.Status?.map((item) =>
            //                         <MenuItem value={item}>{item}</MenuItem>
            //                     )}
            //             </Select>
            //         </FormControl>
            //     );
            // }
        },
        {
            field: 'triggeringReason', headerName: 'Triggering Reason', width: 180, hide: triggeringArr?.some(word => inspectionDetails?.bundleIdEntity[0]?.qualityWorkLogEntity[0]?.triggeringReason?.includes(word)) && true,
            renderCell: (params) => {
                return (
                    <div>{params?.row?.categoryOfInspection === "Grievance" ? params?.row?.bundleIdEntity[0]?.qualityWorkLogEntity[0]?.triggeringReason : params?.row?.triggeringReason}</div>
                )
            }
        },
        { field: 'inspectionEquipmentUsed', headerName: 'Equipment to be used', width: 180 },
        {
            field: 'surprise', headerName: 'Surprise', width: 100,
            renderCell: (params) => {
                return (
                    <div>{params?.value === true ? "Yes" : "No"}</div>
                )
            }
        },
        { field: 'inspectDescription', headerName: 'Description', width: 350 }
    ];

    const equipmentAndSurpriseTable = [
        { field: 'inspectionEquipmentUsed', headerName: 'Equipment to be used', width: 180 },
        {
            field: 'surprise', headerName: 'Surprise', width: 100,
            renderCell: (params) => {
                return (
                    <div>{params?.value === true ? "Yes" : "No"}</div>
                )
            }
        }
    ]

    const commentsColumn = [
        {
            field: 'comments', headerName: t('reg.comments'), width: 500,
            renderCell: (params) => {
                const handleKeyDown = (event) => {
                    if (event.key === ' ') {
                        event.stopPropagation(); // Stops event bubbling to prevent row selection
                    }
                };
                return (
                    params?.row?.id > worklogDetails?.length ? <TextField fullWidth
                        label={t('reg.comment')}
                        name="comments"
                        inputProps={{
                            maxLength: openTextFieldMaxLength
                        }}
                        multiline
                        onKeyDown={handleKeyDown}
                        onChange={(e) => handleCommentChange(e, params?.row?.id)}
                        value={params?.row?.comments}
                        sx={{ width: "100%" }}
                    /> : <div>{params?.value}</div>
                );
            }
        },
        {
            field: 'updtdBy', headerName: 'Changed By', width: 200,
            renderCell: (params) => {
                return (
                    params?.row?.id > worklogDetails?.length ?
                        <>
                            <Button variant="contained" onClick={(e) => updateWorklog(state?.inspectionOrderId, params?.row?.comments, inspectionDetails?.createdOn, inspectionDetails?.id, setWorklogDetails)}>
                                Save
                            </Button>
                            <Button variant="outlined" sx={{ ml: 1 }} onClick={(e) => onCancelComment(params.row)}>
                                Cancel
                            </Button>
                        </> : <div>{params?.value}</div>
                );
            }
        },
        { field: 'updatedOn', headerName: 'Changed Timestamp', width: 200 },
    ]


    const qualityDetailsColumns = [
        {
            field: 'bundleId', headerName: label ? label : "Bundle ID/Heap No/Consignment No", width: 200,
            renderCell: (params) => {
                return (
                    params?.row?.bundleTableId === null ? <FormControl >
                        <InputLabel>{label ? label : "Bundle ID/Heap No/Consignment No"}</InputLabel>
                        <Select
                            label={label ? label : "Bundle ID/Heap No/Consignment No"}
                            name="bundleId"
                            size="small"
                            onChange={(e) => handleNewCheckListChange(e, params?.row?.id, params?.row)}
                            value={params?.row?.bundleId}
                            sx={{ minWidth: 180 }}
                        >
                            <MenuItem value=""><em>Select</em></MenuItem>
                            {
                                selectedBundleIds?.map((item) =>
                                    <MenuItem value={item?.bundleId}>{item?.bundleId}</MenuItem>
                                )}
                        </Select>
                    </FormControl> :
                        <div>{params?.value}</div>
                );
            }
        },
        {
            field: 'qualityParameter', headerName: 'Quality Parameter', width: 160,
            renderCell: (params) => {
                return (
                    params?.row?.bundleTableId === null ? <FormControl >
                        <InputLabel>Quality Parametrer</InputLabel>
                        <Select
                            label="Quality Parametrer"
                            name="qualityParameter"
                            size="small"
                            onChange={(e) => handleNewCheckListChange(e, params?.row?.id, params?.row)}
                            value={params?.row?.qualityParameter}
                            sx={{ minWidth: 140 }}
                        >
                            <MenuItem value=""><em>Select</em></MenuItem>
                            {
                                qualityParameterList?.Quality_parameter?.map((item) =>
                                    <MenuItem value={item} disabled={qualityRows?.find((quaItem) => (quaItem?.bundleId === params?.row?.bundleId) && (quaItem?.qualityParameter === item))}>{item}</MenuItem>
                                )}
                        </Select>
                    </FormControl> :
                        <div>{params?.value}</div>
                );
            }
        },
        {
            field: 'toleranceLimit', headerName: 'Tolerance Limit', width: 140,
            renderCell: (params) => {
                return (
                    <div>{params?.value !== 0 ? params?.value : null}</div>
                    // params?.row?.bundleTableId === null ? <TextField fullWidth
                    //     label="Tolerance Limit"
                    //     diabled={true}
                    //     name="toleranceLimit"
                    //     type="number"
                    //     size="small"
                    //     onKeyDown={(evt) => (evt.key === 'e' || evt.key === 'E' || evt.key === '-' || evt.key === '+') && evt.preventDefault()}
                    //     value={params?.row?.toleranceLimit || ''}
                    //     sx={{ width: "100%" }}
                    // /> :
                    //     <div>{params?.value}</div>
                );
            }
        },
        {
            field: 'minimumLimit', headerName: 'Min Value', width: 140,
            // renderCell: (params) => {
            //     return (
            //         params?.row?.bundleTableId === null ? <TextField fullWidth
            //             label="Min Value"
            //             diabled={true}
            //             name="minimumLimit"
            //             type="number"
            //             size="small"
            //             onKeyDown={(evt) => (evt.key === 'e' || evt.key === 'E' || evt.key === '-' || evt.key === '+') && evt.preventDefault()}
            //             value={params?.row?.minimumLimit || ''}
            //             sx={{ width: "100%" }}
            //         /> :
            //             <div>{params?.value}</div>
            //     );
            // }
        },
        {
            field: 'maximumLimit', headerName: 'Max Value', width: 140,
            // renderCell: (params) => {
            //     return (
            //         params?.row?.bundleTableId === null ? <TextField fullWidth
            //             label="Max Value"
            //             diabled={true}
            //             name="maximumLimit"
            //             type="number"
            //             size="small"
            //             onKeyDown={(evt) => (evt.key === 'e' || evt.key === 'E' || evt.key === '-' || evt.key === '+') && evt.preventDefault()}
            //             value={params?.row?.maximumLimit || ''}
            //             sx={{ width: "100%" }}
            //         /> :
            //             <div>{params?.value}</div>
            //     );
            // }
        },
        {
            field: 'actualQuantity', headerName: 'Actual Value', width: 180,
            // renderCell: (params) => {
            //     return (
            //         params?.row?.bundleTableId === null ? <TextField fullWidth
            //             label="Actual Value"
            //             type="number"
            //             name="actualQuantity"
            //             size="small"
            //             onKeyDown={(evt) => (evt.key === 'e' || evt.key === 'E' || evt.key === '-' || evt.key === '+') && evt.preventDefault()}
            //             onChange={(e) => handleNewCheckListChange(e, params?.row?.id)}
            //             value={params?.row?.actualQuantity}
            //             sx={{ width: "100%" }}
            //         /> :
            //             <div>{params?.value}</div>
            //     );
            // }
        },
        {
            field: 'recordedQuantity', headerName: 'Recorded Value', width: 250,
            renderCell: (params) => {
                return (
                    !triggeringArr?.some(word => inspectionDetails?.bundleIdEntity[0]?.qualityWorkLogEntity[0]?.triggeringReason?.includes(word)) ? <TextField fullWidth
                        label="Recorded Value"
                        type="number"
                        onFocus={handleNumberFieldFocus}
                        name="recordedQuantity"
                        size="small"
                        onKeyDown={(evt) => (evt.key === 'e' || evt.key === 'E' || evt.key === '-' || evt.key === '+') && evt.preventDefault()}
                        onChange={(e) => params?.row?.bundleTableId === null ? handleNewCheckListChange(e, params?.row?.id) : handleChange(e, params?.row?.qualityParameter, params?.row?.bundleId)}
                        defaultValue={params?.row?.recordedQuantity}
                        sx={{ width: "100%" }}
                    /> : <>{params.row.recordedQuantity}</>
                );
            }
        },
        {
            field: 'newQuantity', headerName: 'New Recorded Value', width: 250, hide: !triggeringArr?.some(word => inspectionDetails?.bundleIdEntity[0]?.qualityWorkLogEntity[0]?.triggeringReason?.includes(word)),
            renderCell: (params) => {
                return (
                    <TextField fullWidth
                        label="New Recorded Value"
                        type="number"
                        onFocus={handleNumberFieldFocus}
                        name="newQuantity"
                        size="small"
                        onKeyDown={(evt) => (evt.key === 'e' || evt.key === 'E' || evt.key === '-' || evt.key === '+') && evt.preventDefault()}
                        onChange={(e) => params?.row?.bundleTableId === null ? handleNewCheckListChange(e, params?.row?.id) : handleChange(e, params?.row?.qualityParameter, params?.row?.bundleId)}
                        defaultValue={params?.row?.newQuantity}
                        sx={{ width: "100%" }}
                    />
                );
            }
        },
        {
            field: 'materialCode', headerName: 'Material Code', width: 140, hide: !triggeringArr?.some(word => inspectionDetails?.bundleIdEntity[0]?.qualityWorkLogEntity[0]?.triggeringReason?.includes(word)) && true,
            renderCell: (params) => {
                return (
                    <div>{params?.value}</div>
                    // params?.row?.bundleTableId === null ? <TextField fullWidth
                    //     label="Material Code"
                    //     diabled={true}
                    //     name="materialCode"
                    //     size="small"
                    //     value={params?.row?.materialCode || ''}
                    //     sx={{ width: "100%" }}
                    // /> :
                    //     <div>{params?.value}</div>
                );
            }
        },
        {
            field: 'triggeringReason', headerName: 'Triggering Reason', width: 140, hide: !triggeringArr?.some(word => inspectionDetails?.bundleIdEntity[0]?.qualityWorkLogEntity[0]?.triggeringReason?.includes(word)) && true,
            renderCell: (params) => {
                return (
                    <div>{params?.value}</div>
                    // params?.row?.bundleTableId === null ? <TextField fullWidth
                    //     label="Triggering Reason"
                    //     diabled={true}
                    //     name="Triggering Reason"
                    //     size="small"
                    //     value={params?.row?.triggeringReason || ''}
                    //     sx={{ width: "100%" }}
                    // /> :
                    //     <div>{params?.value}</div>
                );
            }
        },
        {
            field: 'comments', headerName: t('reg.comments'), width: 180,
            renderCell: (params) => {
                const handleKeyDown = (event) => {
                    if (event.key === ' ') {
                        event.stopPropagation(); // Stops event bubbling to prevent row selection
                    }
                };
                return (
                    <TextField fullWidth
                        label="Comments"
                        inputProps={{
                            maxLength: openTextFieldMaxLength
                        }}
                        name="comments"
                        size="small"
                        onKeyDown={handleKeyDown}
                        onChange={(e) => params?.row?.bundleTableId === null ? handleNewCheckListChange(e, params?.row?.id) : handleChange(e, params?.row?.qualityParameter, params?.row?.bundleId)}
                        defaultValue={params?.row?.comments}
                        sx={{ width: "100%" }}
                    />
                );
            }
        },
        {
            field: "actions",
            headerName: "Attachments",
            sortable: false,
            width: 100,
            disableClickEventBubbling: true,
            renderCell: (params) => {
                return (
                    <>
                        {/* <IconButton size="large" color="inherit" onClick={(e) => handleOpenMenu(e, params?.row)}>
                            <AttachFileIcon />
                        </IconButton> */}
                        <Tooltip title="Attachments">
                        <IconButton size="large" color="primary" onClick={(e) => { assignInspection(e, params.row) }}>
                        <AttachFileIcon />                            
                        </IconButton>
                        </Tooltip>
                        <Tooltip title="Cancel">
                        <IconButton size="large" color="primary" onClick={(e) => onCancelRow(params.row)}>
                            <CloseIcon />
                        </IconButton>
                        </Tooltip>
                    </>
                );
            }
        },
        {
            field: "bundleTableId",
            headerName: "Bundle Table Id",
            hide: true,
        },

    ];

    return (
        <>
            <Helmet>
                <title> Conduct Inspection | ABEPL </title>
            </Helmet>
            <Container maxWidth="xl">
                <Typography variant="h4" sx={{ mb: 2 }}>
                    <Fab component={RouterLink} to='/qualitydashboard/inspectionworkorder' size="small" aria-label="back" title='Back'>
                        <KeyboardArrowLeftRounded />
                    </Fab>
                </Typography>
                {inspectionDetails && <Card>
                    <Box style={{ height: 250, width: '100%' }}>
                        <DataGrid
                            rows={[inspectionDetails]}
                            columns={inspectionDetailsColumns}
                            pageSize={10}
                            rowHeight={60}
                            components={{ Toolbar: QuickSearchToolbar }} />
                    </Box>
                </Card>}
                &nbsp;
                <Grid container>
                    <Grid item xs={12} lg={12}>
                        {bundleIdArr && <Card>
                            <CardContent>
                                <Grid container spacing={2}>
                                    <Grid item xs={12} lg={4}>
                                        <Autocomplete
                                            multiple
                                            id="tags-outlined"
                                            disableCloseOnSelect
                                            options={bundleIdArr}
                                            getOptionLabel={(option) => option?.bundleId}
                                            onChange={handleMultiBundleSelect}
                                            renderInput={(params) => (
                                                <TextField
                                                    {...params}
                                                    label={label ? label : "Bundle ID/Heap No/Consignment No"}
                                                    placeholder={label ? label : "Bundle ID/Heap No/Consignment No"}
                                                />
                                            )}
                                        />
                                    </Grid>
                                    <Grid item xs={12} lg={12}>
                                        <Button sx={{ mb: 1 }} onClick={() => onAddNewChecklist()} variant="contained" startIcon={<AddIcon />}>
                                            Add New Checklist
                                        </Button>
                                        <Box style={{ height: 380, width: '100%' }}>
                                            {<DataGrid
                                                rows={qualityRows}
                                                columns={qualityDetailsColumns}
                                                pageSize={5}
                                                components={{ Toolbar: QuickSearchToolbar }} />}
                                        </Box>
                                    </Grid>
                                </Grid>
                            </CardContent>
                        </Card>}
                    </Grid>
                </Grid>
                &nbsp;  &nbsp;
                <Grid container>
                    <Grid item xs={12} lg={12}>
                        <Stack spacing={1}>
                            <Grid container spacing={1}>
                                <Grid item xs={12} lg={12}>
                                    <Button sx={{ mb: 1 }} onClick={() => onAddComment()} variant="contained" startIcon={<AddIcon />}>
                                        Add Comment
                                    </Button>
                                    {inspectionDetails && <Card>
                                        <Box style={{ height: 300, width: '100%' }}>
                                            <DataGrid
                                                rows={commentsRow}
                                                columns={commentsColumn}
                                                pageSize={5}
                                                rowHeight={75}
                                                components={{ Toolbar: QuickSearchToolbar }} />
                                        </Box>
                                    </Card>}
                                </Grid>
                            </Grid>
                        </Stack>
                        &nbsp;
                        &nbsp;
                        <Box display='flex' alignItems="center" justifyContent="center">
                            <Button startIcon={<SaveIcon />} sx={{ minWidth: 120 }} variant="contained" onClick={() => onSubmit(false)} disabled={(localStorage.getItem('role') === "Qty-Incharge" && inspectionDetails?.inspectorEmail) || inspectionDetails?.status === "Closed"}>Save</Button>
                            &nbsp;
                            &nbsp;
                            <Button endIcon={<SubmitIcon />} sx={{ minWidth: 120, mr: 2 }} variant="contained" onClick={() => onSubmit(true)} disabled={(localStorage.getItem('role') === "Qty-Incharge" && inspectionDetails?.inspectorEmail) || inspectionDetails?.status === "Closed"}>Submit</Button>

                        </Box>
                    </Grid>
                </Grid>
            </Container>
            {/* <Popover
                open={Boolean(open)}
                anchorEl={open}
                onClose={handleCloseMenu}
                anchorOrigin={{ vertical: 'top', horizontal: 'left' }}
                transformOrigin={{ vertical: 'top', horizontal: 'right' }}
                PaperProps={{
                    sx: {
                        p: 1,
                        width: 140,
                        '& .MuiMenuItem-root': {
                            px: 1,
                            typography: 'body2',
                            borderRadius: 0.75,
                        },
                    },
                }} >
                <MenuItem onClick={(e) => { assignInspection(e) }}>
                    <Iconify icon={'clarity:assign-user-solid'} sx={{ mr: 2 }} />
                    Attachments
                </MenuItem>
                <MenuItem onClick={(e) => onCancelRow(e)}>
                    <Iconify icon={"material-symbols:cancel"} sx={{ mr: 2 }} />
                    Cancel
                </MenuItem>
            </Popover> */}
            {/* ............................Popover for Assign method......................................... */}
            <Dialog open={Boolean(openAssign)} maxWidth="sm" fullWidth>
                <DialogTitle>Upload Documents</DialogTitle>
                <Box position="absolute" top={0} right={0}>
                    <IconButton onClick={handleCloseMenu}>
                        <CloseIcon />
                    </IconButton>
                </Box>
                <DialogContent>
                    <Stack direction="row" spacing={4}>
                        <Box sx={{ width: '30%' }}>
                            <Grid item xs={12} sm={6} md={6}>
                                <Card style={{ backgroundColor: '#E7EBE8' }}>
                                    <Stack direction="column"
                                        justifyContent="center"
                                        alignItems="center">
                                        <IconButton disabled color="secondary" >
                                            <CloudUploadIcon color="warning"
                                                fontSize="large"
                                            />
                                        </IconButton>
                                        <Button variant="contained" component="label" >Browse
                                            <input id='fileUpload' type="file"
                                                multiple
                                                onChange={(e) => handleDocumentChange(e)}
                                                accept='application/pdf, image/png, image/jpg, image/jpeg'
                                                placeholder="Upload"
                                                style={{ display: "none" }}
                                            />
                                        </Button>
                                        <label style={{ fontSize: '10px' }}>supported files:pdf, png, jpg, jpeg.</label>
                                        <div className='resource-knowledge-error-message' >{errorMessage?.fileUploadError}</div>
                                    </Stack>
                                </Card>
                            </Grid>
                        </Box>
                        <Grid item xs={12} sm={6} md={6}>
                            {qualityDocumentMasterEntity?.filter(item => item?.bundleId === selectedItemForAttachment?.bundleId && item?.qualityParameter === selectedItemForAttachment?.qualityParameter && item?.isActive === 1)?.map((file, index) => (
                                <Stack direction="row">
                                    📁
                                    <Typography variant="fileName" onClick={() => downloadDocument(file)}> {file?.documentName}
                                    </Typography>
                                    <DeleteIcon color="error" fontSize="small" sx={{ mt: 0.5 }} onClick={() => onDeleteFile(file?.documentBlobName)} />
                                </Stack>
                            ))
                            }
                        </Grid>
                    </Stack>
                </DialogContent>
                {/* <DialogActions>
          <Button variant="outlined" onClick={handleCloseMenu}>
            Cancel
          </Button>
          <Button variant="contained" onClick={submitDocuments}>
            Submit
          </Button>
        </DialogActions> */}
            </Dialog>
            <ConfirmationPopover onOpen={logModalOpenSubmit} onConfirm={onConfirmSubmit} action="Submit" onClose={handleLogModalCloseSubmit} />
        </>
    )
}

export default ConductInspectionPage